import React from "react";
import { connect } from "react-redux";
import "./Dashboard.css";
import { Helmet } from "react-helmet";

const Comp = ({ pinsqueue, loadPinQueue, setPinStatus }) => {

    React.useEffect(() => {
        loadPinQueue();
    }, [loadPinQueue]);

    const pq = (status) => {
        if (!pinsqueue) return null;
        return (
            <table className="table is-fullwidth is-striped">
                <thead>
                    <th>name</th>
                    <th>description</th>
                    <th>action</th>
                </thead>
                <tbody>
                    {pinsqueue.filter((item) => { return item.status === status }).map((pin) => {
                        return (
                            <tr className="" key={pin.key}>
                                <td>{pin.key}{pin.key !== pin.hash && (<span> (hash: {pin.hash})</span>)}</td>
                                <td>{pin.description}</td>
                                <td>
                                {pin.status !== 0 && (<button onClick={() => { setPinStatus(pin.id, 0) }}>set pending</button>)}
                                {pin.status !== 1 && (<button onClick={() => { setPinStatus(pin.id, 1) }}>approve</button>)}
                                {pin.status !== 2 && (<button onClick={() => { setPinStatus(pin.id, 2) }}>archive</button>)}
                                </td>
                            </tr>

                        )
                    })}
                </tbody>
            </table>
        )



    }

    return (
        <div className="ryo-container">
            <Helmet>
                <link rel="shortcut icon" href="/pinner.ico" />
            </Helmet>


            <h2>IPFS suggested content</h2>

            {pq(0)}

            <h2>IPFS approved content</h2>

            {pq(1)}

            <h2>IPFS archived content</h2>

            {pq(2)}

        </div>
    )
};

const mapStateToProps = state => {
    return {
        pinsqueue: state.main.pinsqueue,
    };
};

const mapDispachToProps = dispatch => {
    return {
        loadPinQueue: () => dispatch({ type: "LOADPINQUEUE" }),
        setPinStatus: (id, status) => dispatch({ type: "SETPINSTATUS", id: id, status: status }),
    };
};

export default connect(
    mapStateToProps,
    mapDispachToProps
)(Comp);
